<template lang="pug">
.challenge-builder-date-picker-footer
    .level(v-if="isOrganizationChallenge")
      .indicator-key.featured-indicator-key.has-background-primary
      span organization challenge date
    .level
      .indicator-key.startdate-indicator-key.has-background-warning
      span challenge start date
    .level
      .indicator-key.enddate-indicator-key.has-background-info
      span challenge end date
    .level
      .indicator-key.program-indicator-key.has-background-danger
      span program start/end dates
    .level
      li Note, the challenge end date must be before the program end date.
</template>

<script>
/**
 * Data that is rendered in footer of datepicker overlay
 */
export default {
  name: "ChallengeBuilderDatePickerFooter",

  props: {
    featured: {
      type: Boolean,
      default: false
    },
    isOrganizationChallenge: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped>
.indicator-key
  width: 30px
  height: .25em
</style>
